import {
    AfterContentInit, ChangeDetectorRef,
    Component,
    ContentChildren, HostListener, Input, OnChanges,
    QueryList, SimpleChanges,
    TemplateRef,
    ViewEncapsulation
} from '@angular/core';
import {PrimeTemplate} from 'primeng/api';
declare type Nullable<T = void> = T | null | undefined;

@Component({
    selector: 'dmp-tj-tree-table-cell-editor',
    template: `
        <ng-container *ngIf="forceInput">
            <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="!forceInput">
            <ng-container *ngTemplateOutlet="outputTemplate"></ng-container>
        </ng-container>
    `,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'p-element'
    },
    standalone: false
})
export class TjTreeTableCellEditorComponent  implements AfterContentInit {
    @ContentChildren(PrimeTemplate) templates: Nullable<QueryList<PrimeTemplate>>;
    @Input() forceInput = false;

    inputTemplate: Nullable<TemplateRef<any>>;

    outputTemplate: Nullable<TemplateRef<any>>;

    constructor(
                private cdr: ChangeDetectorRef) {}


    ngAfterContentInit() {
        (this.templates as QueryList<PrimeTemplate>).forEach((item) => {
            switch (item.getType()) {
                case 'input':
                    this.inputTemplate = item.template;
                    break;

                case 'output':
                    this.outputTemplate = item.template;
                    break;
            }
        });
    }

}
